import { Box, Typography } from '@mui/material';
import React from 'react';
import Image from 'next/image';
import { FlexList } from '@procore/core-react';
import AnalyticsWrappedComponent from '../Analytics/AnalyticsWrappedComponent';
import ImageLoader from '../utils/ImageLoader';
import { useStyles } from './AdBanner.styles';
import LinkWithArrow from '../ButtonsLinks/LinkWithArrow';

interface Props {
  headline: string;
  subHeadline: string;
  text: string;
  adImagePath: string;
  imageStyle: string;
  link: string;
  dataTrackClick: string;
  analyticsLabel: string;
}

const AdBanner = ({
  headline,
  subHeadline,
  text,
  adImagePath,
  imageStyle,
  link,
  dataTrackClick,
  analyticsLabel,
}: Props) => {
  const classes = useStyles();
  return (
    <Box
      className={classes.container}
      display="flex"
      justifyContent="space-between"
      id="business-profile-ad-banner"
    >
      <Box className={classes.content}>
        <FlexList
          className={classes.logoAndHeadlineContainer}
          boxProps={{ marginRight: 'none', marginLeft: 'none' }}
          wrap="wrap"
        >
          <AnalyticsWrappedComponent
            data-test-id="procore-logo"
            componentType="a"
            eventText="Clicked Procore Logo"
            eventLabel="Header"
            aria-label="Procore logo"
            data-track-click="Ad banner, Logo, Procore"
            href="https://www.procore.com/"
            style={{ marginRight: '12px' }}
          >
            <Image
              loader={ImageLoader}
              src="/procore_logo_light.svg"
              alt="Procore logo"
              width={150}
              height={20}
              loading="eager"
              className={classes.procoreLogo}
            />
            <Image
              loader={ImageLoader}
              src="/procoreEmblem-white.png"
              alt="Procore logo"
              width={25}
              height={24}
              loading="eager"
              className={classes.procoreEmblem}
            />
          </AnalyticsWrappedComponent>
          <Typography className={classes.headline}>{headline}</Typography>
        </FlexList>
        <Typography className={classes.subHeadline}>{subHeadline}</Typography>
        <Typography className={classes.text}>{text}</Typography>
        <LinkWithArrow
          buttonLabel="Learn more"
          buttonLink={link}
          dataTrackClick={dataTrackClick}
          analyticsLabel={analyticsLabel}
          fadeToWhite
          component="h2"
        />
      </Box>
      <Image
        loader={ImageLoader}
        src={adImagePath}
        alt="Procore logo"
        width={100}
        height={100}
        loading="eager"
        className={classes[imageStyle]}
      />
    </Box>
  );
};

export default AdBanner;
